import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/store/auth.store';

// Logged-in pages meant for printing: the same guard as _auth, without the
// sidebar and header around them.
export const Route = createFileRoute('/_print')({
  beforeLoad: ({ location }) => {
    const { accessToken } = useAuthStore.getState();
    if (!accessToken) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: Outlet,
});
